var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSun03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_708_434)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1663 10C14.1663 12.3012 12.3009 14.1667 9.99967 14.1667C7.69849 14.1667 5.83301 12.3012 5.83301 10C5.83301 7.69882 7.69849 5.83334 9.99967 5.83334C12.3009 5.83334 14.1663 7.69882 14.1663 10Z",
    stroke: "#E28B00",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 1.66667V2.91667M9.99984 17.0833V18.3333M15.8922 15.8927L15.0083 15.0089M4.99089 4.99105L4.107 4.10717M18.3332 10H17.0832M2.9165 10H1.6665M15.8926 4.10726L15.0087 4.99115M4.99129 15.009L4.10741 15.8928",
    stroke: "#E28B00",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_708_434"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun03);
export default __webpack_public_path__ + "static/media/sun-03.9d4e28044f7186642e9eb3881a2be40b.svg";
export { ForwardRef as ReactComponent };